import { collection, getDocs, query, where } from "firebase/firestore";
import { db } from "../firebase";

const VAKE_SABURTALO = [
  "vake",
  "bagebi",
  "agaraki",
  "turtle_lake",
  "tkhinvala",
  "saburtalo",
];

export async function getPriceScale(listing) {
  if (!listing) {
    return null;
  }

  // --------------------------------------------------
  // Basic requirements
  // --------------------------------------------------

  const listingType = String(listing.type || "").toLowerCase();
  const listingCity = String(listing.city || "").toLowerCase();
  const listingPurpose = String(listing.purpose || "").toLowerCase();

  if (listingType !== "apartment") {
    console.log("PRICE SCALE: not an apartment", listing.type);
    return null;
  }

  if (listingCity !== "tbilisi") {
    console.log("PRICE SCALE: not Tbilisi", listing.city);
    return null;
  }

  if (
    listingPurpose !== "for_rent" &&
    listingPurpose !== "for_sale"
  ) {
    console.log("PRICE SCALE: unsupported purpose", listing.purpose);
    return null;
  }

  // --------------------------------------------------
  // Get the same published listings used by Listings.js
  // --------------------------------------------------

  const q = query(
    collection(db, "listings"),
    where("status", "==", "published")
  );

const snapshot = await getDocs(q);

console.log(
  "PRICE SCALE FIRESTORE COUNT:",
  snapshot.size
);

snapshot.docs.slice(0, 5).forEach((doc) => {
  console.log(
    "PRICE SCALE SAMPLE:",
    doc.id,
    doc.data()
  );
});


  console.log(
    "PRICE SCALE: published listings found:",
    snapshot.size
  );

  // --------------------------------------------------
  // Build comparable listings
  // --------------------------------------------------

  const comparableListings = snapshot.docs
    .map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }))
    .filter((item) => {
      const type = String(item.type || "").toLowerCase();
      const city = String(item.city || "").toLowerCase();
      const purpose = String(item.purpose || "").toLowerCase();

      // Must be apartment
      if (type !== "apartment") {
        return false;
      }

      // Must be Tbilisi
      if (city !== "tbilisi") {
        return false;
      }

      // Must have same purpose
      if (purpose !== listingPurpose) {
        return false;
      }

      // Sale = only Vake / Saburtalo group
      if (listingPurpose === "sale") {
        const district = String(item.district || "").toLowerCase();
        const localarea = String(item.localarea || "").toLowerCase();
        const neighborhood = String(item.neighborhood || "").toLowerCase();

        const isVakeSaburtalo =
          VAKE_SABURTALO.includes(district) ||
          VAKE_SABURTALO.includes(localarea) ||
          VAKE_SABURTALO.includes(neighborhood);

        if (!isVakeSaburtalo) {
          return false;
        }
      }

      return true;
    });

  console.log(
    "PRICE SCALE: comparable listings:",
    comparableListings.length
  );

  // --------------------------------------------------
  // Calculate GEL per m²
  // --------------------------------------------------

  const prices = comparableListings
    .map((item) => {
      const price = Number(item.price_gel);
      const area = Number(item.area);

      if (
        !Number.isFinite(price) ||
        !Number.isFinite(area) ||
        price <= 0 ||
        area <= 0
      ) {
        return null;
      }

      return price / area;
    })
    .filter((value) => value !== null)
    .sort((a, b) => a - b);

  console.log(
    "PRICE SCALE: valid price/m² values:",
    prices.length
  );

  // Need at least 3 comparable listings
  if (prices.length < 3) {
    console.log("PRICE SCALE: not enough comparable listings");
    return null;
  }

  // --------------------------------------------------
  // Current listing
  // --------------------------------------------------

  const currentPrice = Number(listing.price_gel);
  const currentArea = Number(listing.area);

  if (
    !Number.isFinite(currentPrice) ||
    !Number.isFinite(currentArea) ||
    currentPrice <= 0 ||
    currentArea <= 0
  ) {
    console.log(
      "PRICE SCALE: invalid current price/area",
      currentPrice,
      currentArea
    );

    return null;
  }

  const currentPerM2 = currentPrice / currentArea;

  // --------------------------------------------------
  // Percentile
  // --------------------------------------------------

  const lowerCount = prices.filter(
    (price) => price <= currentPerM2
  ).length;

  const percentile = Math.round(
    (lowerCount / prices.length) * 100
  );

  // --------------------------------------------------
  // Category
  // --------------------------------------------------

  let category;

  if (percentile < 20) {
    category = "low";
  } else if (percentile < 40) {
    category = "below_average";
  } else if (percentile < 60) {
    category = "average";
  } else if (percentile < 80) {
    category = "above_average";
  } else {
    category = "high";
  }

  const result = {
    percentile,
    category,
    pricePerM2: Math.round(currentPerM2),
    min: Math.round(prices[0]),
    max: Math.round(prices[prices.length - 1]),
  };

  console.log("PRICE SCALE: FINAL RESULT:", result);

  return result;
}
